/**
 * @file 教程页页左侧菜单
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useCallback} from 'react';
import {Menu} from 'antd';
import {MenuProps} from 'antd/es/menu';


import LinkA from '../../../../components/a/LinkA';
import {ITutorialsLessonItem} from '../../type';


export interface IDocLeftMenuProps {
    openKeys: string[];
    selectedKeys: string[];
    menuList: ITutorialsLessonItem[];

    onSelect: (selectedKeys: string[]) => void;
    onOpenKeysChange: (openKeys: string[]) => void;
}

const LessonMenu: React.FC<IDocLeftMenuProps> = props => {
    const {
        openKeys,
        selectedKeys,
        onSelect,
        menuList,
        onOpenKeysChange
    } = props;

    const handleOnOpenKeysChange = useCallback<Exclude<MenuProps['onOpenChange'], undefined>>(
        (keys) => {
            onOpenKeysChange(keys.map(k => '' + k));
        },
        [onOpenKeysChange]
    );

    const handleOnSelect = useCallback<Exclude<MenuProps['onSelect'], undefined>>(({selectedKeys}) => {
        onSelect(selectedKeys?.map(k => '' + k) ?? []);
    }, [onSelect]);

    return (
        <Menu
            className="paddle-tutorials-left-menu"
            mode="inline"
            selectedKeys={selectedKeys}
            inlineIndent={10}
            openKeys={openKeys}
            onOpenChange={handleOnOpenKeysChange}
            onSelect={handleOnSelect}
            expandIcon={(
                <i className="paddle-tutorials-left-menu-arrow" />
            )}
        >
            {menuList.map(lession => (
                <Menu.SubMenu
                    key={lession.id}
                    title={<span title={lession.title}>{lession.title}</span>}
                >
                    {lession.projectList?.map(project => (
                        <Menu.Item key={project.id} title={project.title}>
                            <LinkA
                                to={project.link}
                                title={project.title}
                            >
                                {project.title}
                            </LinkA>
                        </Menu.Item>
                    ))}
                </Menu.SubMenu>
            ))}
        </Menu>
    );
};

export default LessonMenu;
